import axios from "axios";

export async function getProjects({ commit }, payload) {
  const { data } = await axios.get(`project/get-by-client`, {
    params: payload,
  });
  return data;
}

export async function getById({ commit }, payload) {
  const { data } = await axios.get(`project/get-by-id`, {
    params: payload,
  });
  return data;
}

export async function create({ commit }, payload) {
  const { data } = await axios.post(`project/add`, payload);
  return data;
}

export async function update({ commit }, payload) {
  const { data } = await axios.put(`project/update`, payload.body, {
    params: payload.query,
  });
  return data;
}

export async function addApplication({ commit }, payload) {
  const { data } = await axios.put(`project/add-application`, payload.body, {
    params: payload.query,
  });
  return data;
}

export async function removeApplicationInProject({ commit }, payload) {
  console.log(payload);
  const { data } = await axios.put(
    `project/remove-application`,
    {},
    {
      params: payload,
    }
  );
  return data;
}

export async function addFarmDescription({ commit }, { params, payload }) {
  const { data } = await axios.put(`project/add-farm-description`, payload, {
    params: params,
  });
  return data;
}
